module.exports = __webpack_public_path__ + "img/mob_about_02_new.d3a885ba.png";